export default __webpack_public_path__ + "static/reading-6ec4807b2635d5f027b66d5c38d02541.jpg";